<template>
    <div class="animated fadeIn">
         <div class="card" style="margin:0px 15px 10px 15px">
            <div class="row" style="padding: 20px;background-color:#fff">
                <div class="col-md-8">
                    <p style="font-size: 16px;">This pages shows loan application rejection redflags for this customer</p>
                </div>
                <div class="col-md-4">
                    <p class="text-right">
                        <b-link v-show="!loading" @click="goBack()">
                            <span class="fa fa-arrow-left"></span> Return Back
                        </b-link>
                    </p>
                </div>
            </div>
        </div>
        <b-row>
            <b-col cols="12" lg="12">
                <p v-if="loading" style="text-align: center;padding: 20px">
                    <span style="font-size: 25px;">
                        <i class="fa fa-spinner fa-spin"></i> Loading...
                    </span>
                </p>
                <div v-else>
                    <b-card :header="`Details`">
                        <div v-if="userRedflag.length < 1">
                            <p style="font-size: 15px;" class="text-center">
                                <i>There are currently no redflags for this customer.</i>
                            </p>
                        </div>
                        <table class="table table-hover" v-else>
                            <thead>
                                <tr>
                                    <th scope="col">SN</th>
                                    <th scope="col">Type</th>
                                    <th scope="col">Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(data, index) in userRedflag" v-bind:key="index">
                                    <th scope="row">{{++index}}</th>
                                    <td>{{data.type}}</td>
                                    <td>{{data.description}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </b-card>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
    name: 'redflags',
    data: () => {
        return {}
    },
    computed: {
        ...mapState([
            'userRedflag',
            'loading'
        ])
    },
    methods: {
        ...mapActions([
            'getRedflag',
            'getUserDetails'
        ]),
        async UserRedflag(user_id) {
            await this.getRedflag(user_id);
        }
    },
    async created() {
        const user_id = this.$route.params.user_id;
        await this.getRedflag(user_id);
    },
}
</script>